var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { AppConfigurationLookupServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
var ClientCodesMultiSelectComponent = /** @class */ (function (_super) {
    __extends(ClientCodesMultiSelectComponent, _super);
    function ClientCodesMultiSelectComponent(injector, _appConfigurationLookupServiceProxy) {
        var _this = _super.call(this, injector) || this;
        _this._appConfigurationLookupServiceProxy = _appConfigurationLookupServiceProxy;
        _this.name = 'ClientFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.placeholder = _this.l('Client');
        _this.options = new Array();
        _this._selectedItems = [];
        return _this;
    }
    Object.defineProperty(ClientCodesMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (items) {
            this._selectedItems = items || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ClientCodesMultiSelectComponent.prototype.ngOnInit = function () {
        if (this.selectedItems.length) {
            this.getClientCodes();
        }
    };
    ClientCodesMultiSelectComponent.prototype.getClientCodes = function () {
        var _this = this;
        this._appConfigurationLookupServiceProxy.getClientsWithCode('')
            .subscribe(function (clientCodes) {
            _this.options = clientCodes;
        });
    };
    ClientCodesMultiSelectComponent.prototype.onPanelShow = function () {
        if (!this.options.length) {
            this.getClientCodes();
        }
    };
    ClientCodesMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return ClientCodesMultiSelectComponent;
}(AppComponentBase));
export { ClientCodesMultiSelectComponent };
